module.exports = __webpack_public_path__ + "static/media/HCMM005.95d957dc.jpg";